<template>
  <v-form>
    <v-container fluid>
      <v-card elevation="12" class="pa-10">
        <v-row>
          <v-col>
            <h2>Sítio Ativo - FRAC</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Grupo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="grupos"
              v-model="sitio.id_grupo"
              item-text="grupo"
              item-value="id"
              label="Grupo"
              dense
              outlined
              no-data-text="Adicione um Grupo para selecionar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Subgrupo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="sitio.subgrupo"
              :rules="fieldRequired"
              label="Subgrupo"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Sítio Ativo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="sitio.sitio"
              :rules="fieldRequired"
              label="Sítio Ativo"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Codigo FRAC</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="sitio.codigo_frac"
              :rules="fieldRequired"
              label="Codigo FRAC"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn dark style="margin-left: 5px; margin-top: 2px" color="green" @click="salvar">
              Salvar
            </v-btn>
            <v-btn
              style="margin-left: 5px; margin-top: 2px"
              color="gray"
              to="/frac/sitio"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
    >
      {{ aviso }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { BASE_URL } from '../../util/constants';
export default {
  data: () => ({
    url: "https://apiadmin.allgeconsultoria.com/index.php/frac/",
    overlay: false,
    snackbar: false,
    aviso: '',
    grupos: [],
    sitio: {
      id: "",
      id_grupo: "",
      subgrupo: '',
      sitio: '',
      codigo_frac: '',
    },
    fieldRequired: [(v) => !!v || "Campo Obrigatorio"],
  }),
  created() {
    this.url = `${BASE_URL}frac/`;
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchGrupos();
      if (this.$route.params.id !== "") {
        await this.fetchSitio(this.$route.params.id);
      }
    },
    async fetchGrupos() {
      try {
        let response = await fetch(`${this.url}grupo`);
        response = await response.json();
        this.grupos = response.map(item => ({id: item.id, grupo: item.grupo}));
      } catch (error) {
        this.grupos = [];
      }
    },
    async fetchSitio(id) {
      try {
        let response = await fetch(`${this.url}sitio/${id}`);
        response = await response.json();
        this.sitio = response;
      } catch (error) {
        this.sitio = {
          id: "",
          id_grupo: "",
          subgrupo: '',
          sitio: '',
          codigo_frac: '',
        };
      }
    },
    async salvar() {
      this.overlay = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("subgrupo", this.sitio.subgrupo);
      urlencoded.append("sitio", this.sitio.sitio);
      urlencoded.append("codigo_frac", this.sitio.codigo_frac);
      urlencoded.append("id_grupo", this.sitio.id_grupo);
      let method = (this.sitio.id === '' ? 'POST' : 'PUT')
      
      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: urlencoded,
      };

      fetch(`${this.url}sitio/${this.sitio.id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          this.overlay = false;
          this.aviso = 'Salvo com Sucesso';
          this.snackbar = true;
          setTimeout(() => this.$router.push(`/frac/sitio/`), 1000)
        })
        .catch(error => {
          console.log(error)
          this.overlay = false;
          this.aviso = 'Problema ao Salvar, entre em contato com o suporte';
          this.snackbar = true;
        });
    }
  },
};
</script>
